import 'jquery';
import 'bootstrap';

import selectAll from './helper_modules/select_all';

export const closeAlertBox = () => {
  // Since v2 views don't incorporate bootstrap, which would normally handle
  // dismissing flash messages, we have to implement it ourselves.
  $(`.alert-close`).click(() => {
    $(`.alert-box`).remove();
  });
};

export const bindAutoSubmit = () => {
  // Utility for creating inputs that auto submit the form they're in.
  $(`.auto_submit_form_item`).change((e) => $(e.target).parents(`form`).submit());
};

export const bindClickOnModalContent = () => {
  $(`.loadModalContent`).on(`click`, (e) => {
    e.preventDefault();
    const $form = $($(e.target).data(`form`));
    const data = $form.serialize();
    const modalId = $(e.target).data(`target`);
    $.ajax({
      method: $form.attr(`method`),
      url: $form.attr(`action`),
      data,
      success(msg) {
        $(modalId).find(`.modal-body`).html(msg);
        $(modalId).modal(`show`);
      },
    });
  });
};

export const bindClickOnSubmitForm = () => {
  $(`.submitForm`).on(`click`, (e) => {
    e.preventDefault();
    const $form = $($(e.target).data(`form`));
    $form.submit();
  });
};

const disableField = (e, bool) => {
  e.prop(`disabled`, bool);
};

export const bindClickOnConsolidated = () => {
  $(`.toggleInput`).on(`click`, (e) => {
    const targetId = $(e.target).data(`target`);
    disableField($(targetId), !$(e.target).prop(`checked`));
  });
};

export const bindChangeOnShippingMethod = () => {
  $(`.toggleSelect`).change((e) => {
    const targetId = $(e.target).data(`target`);
    if (e.target.value === `PARCEL`) {
      disableField($(targetId), false);
    } else {
      disableField($(targetId), true);
    }
  });
};

export const bindClickOnSelectAll = () => {
  $(`#selectAll, .selectAll`).on(`click`, (e) => {
    const checkClass = $(e.target).data(`check-class`) || `.check`;
    const checkboxes = $(checkClass).filter((i, el) => !$(el).prop(`disabled`));
    $(e.target).prop(`checked`);
    checkboxes.prop(`checked`, $(e.target).prop(`checked`));
    e.stopPropagation();
    selectAll();
  });
};

export const bindClickOnCheck = () => {
  $(`.check`).on(`click`, () => {
    selectAll();
  });
};

const Helpers = {
  bindEvents() {
    bindAutoSubmit();
    bindClickOnModalContent();
    bindClickOnSubmitForm();
    bindClickOnSelectAll();
    bindClickOnCheck();
    bindClickOnConsolidated();
    bindChangeOnShippingMethod();
    closeAlertBox();
  },
};

export default Helpers;
